<template>
  <div class="hc-date-range-filter" role="group" aria-label="Filter rentang tanggal">
    <div class="hc-date-range-filter__field">
      <b-form-input
        v-model="startModel"
        type="text"
        placeholder="Tanggal awal"
        autocomplete="off"
        readonly
        aria-label="Tanggal awal"
      />
      <b-form-datepicker
        v-model="startModel"
        button-only
        right
        reset-button
        locale="id"
        label-no-date-selected="Pilih tanggal awal"
      />
    </div>

    <span class="hc-date-range-filter__separator">s/d</span>

    <div class="hc-date-range-filter__field">
      <b-form-input
        v-model="endModel"
        type="text"
        placeholder="Tanggal akhir"
        autocomplete="off"
        readonly
        aria-label="Tanggal akhir"
      />
      <b-form-datepicker
        v-model="endModel"
        button-only
        right
        reset-button
        locale="id"
        label-no-date-selected="Pilih tanggal akhir"
      />
    </div>

    <div class="hc-date-range-filter__actions">
      <button type="button" class="hc-date-range-filter__search" @click="$emit('search')">
        <i class="fas fa-search" aria-hidden="true"></i>
        Cari
      </button>
      <button type="button" class="hc-date-range-filter__reset" @click="$emit('reset')">
        Reset
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HcDateRangeFilter',
  props: {
    startDate: { type: String, default: '' },
    endDate: { type: String, default: '' },
  },
  computed: {
    startModel: {
      get() {
        return this.startDate
      },
      set(value) {
        this.$emit('update:startDate', value)
      },
    },
    endModel: {
      get() {
        return this.endDate
      },
      set(value) {
        this.$emit('update:endDate', value)
      },
    },
  },
}
</script>
